<h2 mat-dialog-title>
  {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.CLOSE.OPPORTUNITY_CLOSE' | translate }}
</h2>
<mat-dialog-content>
  {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.CLOSE.MESSAGE' | translate }}
  <br />
  <br />
  <form [formGroup]="closeOpportunityForm" novalidate>
    <ng-container *ngIf="isCloseStateNullOrUndefined(); then selectState"></ng-container>
    <ng-template #selectState>
      <mat-form-field class="select--block" [hidden]="true">
        <mat-label>
          {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.CLOSE.CLOSE_STATE' | translate }}
        </mat-label>
        <mat-select id="close-opportunity-form--close-state" formControlName="closeState">
          <mat-option *ngFor="let closeStateOption of closeStateOptions" [value]="closeStateOption.value">
            {{ closeStateOption.displayValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>
    <mat-form-field class="select--block" *ngIf="closeOpportunityForm.value.closeState === closeState.LOST">
      <mat-label>
        {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.CLOSE.CLOSED_LOST.REASON' | translate }}
      </mat-label>
      <mat-select id="close-opportunity-form--reason" formControlName="reason">
        <mat-option [value]="defaultReason.value">
          {{ defaultReason.displayValue }}
        </mat-option>
        <!--        <ng-container *ngIf="hasAccessToZendeskClosedLostReasons$ | async">-->
        <!--          <mat-optgroup *ngFor="let reasons of zendeskClosedLostReasonGroups" [label]="reasons.name">-->
        <!--            <mat-option *ngFor="let reason of reasons.closedLostReasons" [value]="reason.value">-->
        <!--              {{ reason.displayValue }}-->
        <!--            </mat-option>-->
        <!--          </mat-optgroup>-->
        <!--        </ng-container>-->
        <mat-option *ngFor="let reasonOption of reasonOptions" [value]="reasonOption.value">
          {{ reasonOption.displayValue }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field id="close-opportunity-form--notes" class="notes-field">
      <textarea
        matInput
        placeholder="{{ 'FRONTEND.SALES_UI.COMMON.NOTES' | translate }}"
        formControlName="notes"
      ></textarea>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button id="close-opportunity-form--cancel" mat-dialog-close>
    {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button
    id="close-opportunity-form--close-opportunity"
    mat-flat-button
    color="primary"
    type="submit"
    [disabled]="!closeOpportunityForm.valid"
    (click)="dialogRef.close(closeOpportunityForm.value)"
  >
    {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.CLOSE.CLOSE_OPPORTUNITY' | translate }}
  </button>
</mat-dialog-actions>
